import { Component, forwardRef, inject, input } from '@angular/core';
import { InventoryActionDetailsComponent } from '../../../../inventory/actions/details/inventory-action-details.component';
import { MatDialogRef } from '@angular/material/dialog';
import { Location, TitleCasePipe } from '@angular/common';
import { Folder } from '../../../../models/folder.model';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { CommonPipesModule } from '../../../../shared/pipes/common-pipes.module';
import { ChipComponent } from '../../../../shared/ui/chip/chip.component';
import { FolderStatusPipe } from '../../../pipes/folder-status.pipe';
import { MatCardModule } from '@angular/material/card';
import { ProviderService } from '../../../../providers/provider.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GoToDetailsDirective } from '../../../../shared/directives/go-to-details.directive';
import { MatButtonModule } from '@angular/material/button';


@Component({
  selector: 'app-inventory-action-pricing-details',
  templateUrl: './folder-inventory-action-pricing-details.component.html',
  styleUrls: [
    './folder-inventory-action-pricing-details.component.scss',
    '../../folder-details.component.scss',
  ],
  imports: [
    ChipComponent,
    CommonPipesModule,
    FolderStatusPipe,
    forwardRef(() => GoToDetailsDirective),
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatToolbarModule,
    MatTooltipModule,
    TitleCasePipe,
  ]
})
export class FolderInventoryActionPricingComponentDetails {
  dialogRef = input<MatDialogRef<InventoryActionDetailsComponent>>();

  folder = input.required<Folder>();

  reload = input<() => void>();

  private readonly providerService = inject(ProviderService);

  private readonly location = inject(Location);

  get approvedQuantityFrom(): Record<number, number> {
    const approvedPricings = this.documents.filter((pricing) => pricing.completed);
    const mapProductWithQuantity = approvedPricings
      .flatMap((pricing) => pricing.extra_params.selected_products)
      .reduce((acc, product) => {
        acc[product.product_id] = (acc[product.product_id] || 0) + product.quantity;
        return acc;
      }, {});

    return mapProductWithQuantity;
  }

  get inventoryActionProducts() {
    return this.folder()?.extra_params.required_products.sort((a, b) => a.id < b.id ? -1 : 1);
  }

  get documents() {
    return this.folder()?.documents.sort((a, b) => a.owner.name < b.owner.name ? -1 : 1);
  }

  get providers() {
    return this.providerService.getFromIds(this.folder().extra_params?.provider_ids);
  }

  sortedProducts(inventoryActionProducts) {
    return inventoryActionProducts.sort((a, b) => a.id < b.id ? -1 : 1);
  }

  protected goBack() {
    if (this.dialogRef() instanceof MatDialogRef) {
      this.dialogRef().close();
    } else {
      this.location.back();
    }
  }
}
